import script from "./Kirjaudu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Kirjaudu.vue?vue&type=script&setup=true&lang=ts"

import "./Kirjaudu.vue?vue&type=style&index=0&id=0c92e7d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c92e7d8"]])

export default __exports__